import React from 'react';
import { useMultiCanvasViewStore } from '../../../stores/multiCanvasViewStore';
import {
  getCanvasProjectionDefinition,
  type CanvasProjectionPaneProps,
} from './CanvasProjectionRegistry';

export const CanvasProjectionPaneHost: React.FC<CanvasProjectionPaneProps> = (props) => {
  const activeProjection = useMultiCanvasViewStore((state) => state.activeProjection);
  if (!activeProjection) return null;

  const definition = getCanvasProjectionDefinition(activeProjection.kind);
  if (!definition) return null;
  if (definition.supportsDiagramType && !definition.supportsDiagramType(props.diagramType)) {
    return null;
  }

  const ProjectionPane = definition.component;
  return <ProjectionPane {...props} />;
};
